<div class="home-page">
  <!-- Hero Banner -->
  <section class="hero-banner">
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title">
          Encontre a peça perfeita para o seu veículo
        </h1>
        <p class="hero-subtitle">
          Faróis, lanternas, retrovisores e muito mais
        </p>
        <a routerLink="/produtos" class="btn btn-orange btn-lg">
          Ver todos os produtos
        </a>
      </div>
    </div>
  </section>

  <!-- Categorias Principais -->
  <section class="categories-section">
    <div class="container">
      <h2 class="section-title">Compre por categoria</h2>
      
      <div class="categories-grid">
        @for (category of categories(); track category.id) {
          <a 
            [routerLink]="['/categoria', category.slug]"
            class="category-card card"
            [style.background-image]="'linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.7) 100%), url(' + getCategoryImage(category.slug) + ')'"
          >
            <h3 class="category-name">{{ category.nome }}</h3>
          </a>
        }
      </div>
    </div>
  </section>

  <!-- Produtos em Destaque -->
  <section class="featured-section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">Produtos em destaque</h2>
        <a routerLink="/produtos" class="btn btn-link">
          Ver todos →
        </a>
      </div>

      @if (isLoading()) {
        <div class="products-grid">
          @for (item of [1,2,3,4,5,6,7,8]; track item) {
            <div class="product-skeleton card">
              <div class="skeleton skeleton-image"></div>
              <div class="card-body">
                <div class="skeleton skeleton-title"></div>
                <div class="skeleton skeleton-text"></div>
                <div class="skeleton skeleton-price"></div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="products-grid fade-in">
          @for (product of featuredProducts(); track product.id) {
            <app-product-card [product]="product"></app-product-card>
          }
        </div>
      }
    </div>
  </section>

  <!-- Footer -->
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h4 class="footer-title">Alves Faróis & Auto Peças</h4>
          <p class="footer-text">
            Especialistas em iluminação automotiva e peças de reposição.
            Qualidade garantida desde 1995.
          </p>
          <div class="social-links">
            <a href="https://www.instagram.com/alvesfaroiseautopecas/" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="Instagram">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
          </div>
        </div>

        <div class="footer-section">
          <h4 class="footer-title">Categorias</h4>
          <ul class="footer-links">
            <li><a routerLink="/categoria/farois">Faróis</a></li>
            <li><a routerLink="/categoria/lanternas">Lanternas</a></li>
            <li><a routerLink="/categoria/retrovisores">Retrovisores</a></li>
            <li><a routerLink="/produtos">Todos os produtos</a></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4 class="footer-title">Contato</h4>
          <ul class="footer-links contact-list">
            <li class="contact-item">
              <img src="assets/icons/whatsapp.svg" alt="WhatsApp" class="contact-icon" />
              <a href="https://wa.me/5534996363645" target="_blank" rel="noopener noreferrer">
                (34) 9 9636-3645
              </a>
            </li>
            <li class="contact-item">
              <img src="assets/icons/email.svg" alt="Email" class="contact-icon" />
              <a href="mailto:contato@alvesfarois.com.br">
                contato@alvesfarois.com.br
              </a>
            </li>
            <li class="contact-item">
              <img src="assets/icons/clock.svg" alt="Horário" class="contact-icon" />
              <span>Seg-Sex: 8h às 18h</span>
            </li>
          </ul>
        </div>

        <div class="footer-section">
          <h4 class="footer-title">Localização</h4>
          <address class="footer-address">
            <p>Av. Fernando Vilela, 245</p>
            <p>Uberlândia - MG</p>
            <p>CEP 38400-456</p>
          </address>
          <a 
            href="https://maps.app.goo.gl/5U4XuyBD6yU3YBPP6" 
            target="_blank" 
            rel="noopener noreferrer"
            class="btn btn-secondary btn-sm mt-md"
          >
            Ver no mapa
          </a>
        </div>
      </div>

      <!-- Google Maps -->
      <div class="footer-map">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.852857142857!2d-48.27953!3d-18.91869!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a4450e7e8c7f5d%3A0x1234567890abcdef!2sAv.%20Fernando%20Vilela%2C%20245%20-%20Martins%2C%20Uberl%C3%A2ndia%20-%20MG%2C%2038400-456!5e0!3m2!1spt-BR!2sbr!4v1234567890123"
          width="100%" 
          height="300" 
          style="border:0;" 
          allowfullscreen="" 
          loading="lazy" 
          referrerpolicy="no-referrer-when-downgrade"
          title="Localização Alves Faróis & Auto Peças - Av. Fernando Vilela, 245, Uberlândia"
        ></iframe>
      </div>

      <div class="footer-bottom">
        <p class="footer-copyright">
          © {{ currentYear }} Alves Faróis & Auto Peças. Todos os direitos reservados.
        </p>
      </div>
    </div>
  </footer>
</div>

